// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import deliveryDate from './delivery-date';
import formatting from './formatting';
import registrationDate from './registration-date';
import registrationStatus from './registration-status';
import report from './report';
import reportIsScrollable from '../../shared/reducers/report-is-scrollable';
import selectedDealers from './selected-dealers';
import showNoResultsFound from '../../shared/reducers/show-no-results-found';
import views from './views';

export const getCombinedReducers = () =>
    combineReducers({
        busyCounter,
        deliveryDate,
        formatting,
        registrationDate,
        registrationStatus,
        report,
        reportIsScrollable,
        selectedDealers,
        showNoResultsFound,
        views
    });



// WEBPACK FOOTER //
// ./src/reports/registrations-review/reducers/index.js